module.exports = __webpack_public_path__ + "img/autosense-landing-page-large.1d984d09.png";